<div class="row" *ngIf="paginationInfo && paginationInfo.total > 0">
  <!-- Pagination Info -->
  <div class="col-sm-6 py-4 d-flex align-items-center">
    <div class="dataTables_info">
      <span *ngIf="!loading">
        Showing {{ startRecord }} to {{ endRecord }} of {{ paginationInfo.total }} records
      </span>
      <span *ngIf="loading" class="text-muted">
        <span class="spinner-border spinner-border-sm me-2"></span>
        Loading...
      </span>
    </div>
  </div>
  
  <!-- Pagination Controls -->
  <div class="col-sm-6 py-4 d-flex justify-content-end">
    <nav aria-label="pagination" class="dt-paging paging_full">
      <ul class="pagination">
        <!-- First Page -->
        <li class="page-item" [class.disabled]="isFirstPage || loading">
          <button 
            class="page-link" 
            (click)="onFirstPage()"
            [disabled]="isFirstPage || loading"
            type="button">
            <i class="ki-duotone ki-double-left">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
          </button>
        </li>
        
        <!-- Previous Page -->
        <li class="page-item" [class.disabled]="isFirstPage || loading">
          <button 
            class="page-link" 
            (click)="onPreviousPage()"
            [disabled]="isFirstPage || loading"
            type="button">
            <i class="ki-duotone ki-left"></i>
          </button>
        </li>
        
        <!-- First page if ellipsis -->
        <li class="page-item" *ngIf="showEllipsisStart">
          <button 
            class="page-link" 
            (click)="onPageClick(1)"
            [disabled]="loading"
            type="button">
            1
          </button>
        </li>
        
        <!-- Start ellipsis -->
        <li class="page-item disabled" *ngIf="showEllipsisStart">
          <span class="page-link">...</span>
        </li>
        
        <!-- Page Numbers -->
        <li 
          class="page-item" 
          *ngFor="let page of visiblePages"
          [class.active]="page === paginationInfo.currentPage">
          <button 
            class="page-link" 
            (click)="onPageClick(page)"
            [disabled]="loading"
            type="button">
            {{ page }}
          </button>
        </li>
        
        <!-- End ellipsis -->
        <li class="page-item disabled" *ngIf="showEllipsisEnd">
          <span class="page-link">...</span>
        </li>
        
        <!-- Last page if ellipsis -->
        <li class="page-item" *ngIf="showEllipsisEnd">
          <button 
            class="page-link" 
            (click)="onPageClick(paginationInfo.lastPage)"
            [disabled]="loading"
            type="button">
            {{ paginationInfo.lastPage }}
          </button>
        </li>
        
        <!-- Next Page -->
        <li class="page-item" [class.disabled]="isLastPage || loading">
          <button 
            class="page-link" 
            (click)="onNextPage()"
            [disabled]="isLastPage || loading"
            type="button">
            <i class="ki-duotone ki-right"></i>
          </button>
        </li>
        
        <!-- Last Page -->
        <li class="page-item" [class.disabled]="isLastPage || loading">
          <button 
            class="page-link" 
            (click)="onLastPage()"
            [disabled]="isLastPage || loading"
            type="button">
            <i class="ki-duotone ki-double-right">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
          </button>
        </li>
      </ul>
    </nav>
  </div>
</div>
